"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgePreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const component_2 = require("@front/layouts/default-layout/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="knowledge-preview-page">
    <div class="row">
      <div class="col-lg-12 col-12 pb-lg-5">
        <div class="mb-2" ?hidden="${x => x.compact}">
          <h1>${'knowledge.preview.title'.t()}</h1>
          <div class="text-zero top-right-button-container">
            <button @click="${(x, c) => x.edit()}" type="button" class="top-right-button mr-2 btn btn-primary btn-lg"
              ?disabled="${x => !x.knowledgeId}">
              ${'knowledge.preview.edit'.t()}
            </button>
            <button @click="${(x, c) => x.back()}" type="button" class="top-right-button btn btn-primary btn-lg">
              ${'knowledge.preview.back'.t()}
            </button>
          </div>
        </div>

        ${(0, fast_element_1.when)(x => x.knowledge, (0, fast_element_1.html) `
        
        <div class="row mb-4">
          
          <div class="col-lg-8 mb-3">
            <div class="card shadow-sm h-100">
              <div class="card-body">
                <h5 class="card-title text-secondary mb-4">
                  <i class="simple-icon-notebook mr-2"></i>
                  ${'knowledge.preview.section.basic_info'.t()}
                </h5>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 mr-3">
                        <div class="icon-circle bg-light text-muted">
                          <i class="simple-icon-note"></i>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted d-block">${'knowledge.form.title.label'.t()}</small>
                        <strong>${x => { var _a; return ((_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.title) || 'knowledge.preview.not_provided'.t(); }}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 mr-3">
                        <div class="icon-circle bg-light text-muted">
                          <i class="simple-icon-doc"></i>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted d-block">${'knowledge.form.content_type.label'.t()}</small>
                        <strong>${x => x.contentTypeLabel}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 mr-3">
                        <div class="icon-circle bg-light text-muted">
                          <i class="${x => x.ragStatusIcon}"></i>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted d-block">${'knowledge.form.rag_status.label'.t()}</small>
                        <strong class="${x => x.ragStatusClass}">${x => x.ragStatusLabel}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 mr-3">
                        <div class="icon-circle bg-light text-muted">
                          <i class="simple-icon-check"></i>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted d-block">${'knowledge.form.active.label'.t()}</small>
                        <strong>${x => {
    var _a;
    return ((_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.active) ? 'knowledge.preview.active.yes'.t() :
        'knowledge.preview.active.no'.t();
}}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 mr-3">
                        <div class="icon-circle bg-light text-muted">
                          <i class="simple-icon-folder"></i>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted d-block">${'knowledge.form.project.label'.t()}</small>
                        <strong>${x => { var _a, _b; return ((_b = (_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b.name) || 'knowledge.no_project'.t(); }}</strong>
                      </div>
                    </div>
                  </div>
                </div>

                
                ${(0, fast_element_1.when)(x => { var _a; return (_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.description; }, (0, fast_element_1.html) `
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="d-flex align-items-start">
                      <div class="flex-shrink-0 mr-3">
                        <div class="icon-circle bg-light text-muted">
                          <i class="simple-icon-info"></i>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted d-block">${'knowledge.form.description.label'.t()}</small>
                        <div class="mt-1">${x => { var _a; return (_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.description; }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                `)}

                
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="d-flex align-items-start">
                      <div class="flex-shrink-0 mr-3">
                        <div class="icon-circle bg-light text-muted">
                          <i class="simple-icon-tag"></i>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted d-block">${'knowledge.form.tags.label'.t()}</small>
                        <div class="mt-1">${x => x.getTagsDisplay()}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <div class="col-lg-4 mb-3">
            <div class="card shadow-sm h-100">
              <div class="card-body">
                <h5 class="card-title text-secondary mb-3">
                  <i class="simple-icon-doc mr-2"></i>
                  ${'knowledge.preview.section.file_info'.t()}
                </h5>
                ${(0, fast_element_1.when)(x => { var _a; return (_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.file; }, (0, fast_element_1.html) `
                <div class="text-center">
                  <div class="mb-3">
                    <i class="simple-icon-paper-clip" style="font-size: 3rem;"></i>
                  </div>
                  <div class="mb-2">
                    <strong>${x => x.getFileDisplayName()}</strong>
                  </div>
                  <div class="text-muted">
                    <small>${x => x.getFileSize()}</small>
                  </div>
                </div>
                `, (0, fast_element_1.html) `
                <div class="text-center text-muted">
                  <div class="mb-3">
                    <i class="simple-icon-note" style="font-size: 3rem;"></i>
                  </div>
                  <div>${'knowledge.preview.no_file'.t()}</div>
                </div>
                `)}
              </div>
            </div>
          </div>
        </div>

        
        ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.content) && x.knowledge.contentType === 'text'; }, (0, fast_element_1.html) `
        <div class="row mb-4">
          <div class="col-12">
            <div class="card shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-secondary mb-3">
                  <i class="simple-icon-speech mr-2"></i>
                  ${'knowledge.preview.section.content'.t()}
                </h5>
                <div class="content-display">
                  <pre class="text-wrap">${x => { var _a; return (_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.content; }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
        `)}

        ${(0, fast_element_1.when)(x => { var _a; return (_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.ragError; }, (0, fast_element_1.html) `
        <div class="row mb-4">
          
          <div class="col-lg-12 mb-3">
             <div class="card shadow-sm h-100">
              <div class="card-body">
                <h5 class="card-title text-danger mb-3">
                  <i class="simple-icon-shield mr-2"></i>
                  ${'knowledge.preview.section.errors'.t()}
                </h5>

                <p :innerHTML="${x => { var _a; return x.nl2br((_a = x.knowledge) === null || _a === void 0 ? void 0 : _a.ragError); }}" class="text-danger text-wrap"></p>
                  
                </p>
              </div>
            </div>
          </div>
        </div>`)}


        
        <div class="row mb-4">
          
          <div class="col-lg-6 mb-3">
            <div class="card shadow-sm h-100">
              <div class="card-body">
                <h5 class="card-title text-secondary mb-3">
                  <i class="simple-icon-people mr-2"></i>
                  ${'knowledge.preview.section.used_by_avatars'.t()}
                </h5>
                ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                <div class="text-center">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">${'common.loading'.t()}</span>
                  </div>
                </div>
                `, (0, fast_element_1.html) `
                ${(0, fast_element_1.when)(x => x.usage.avatars.length > 0, (0, fast_element_1.html) `
                <div class="list-group list-group-flush">
                  ${(0, fast_element_1.repeat)(x => x.usage.avatars, (0, fast_element_1.html) `
                  <div class="list-group-item px-0">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 mr-3">
                        <i class="simple-icon-user text-primary"></i>
                      </div>
                      <div>
                        <strong>${x => x.name}</strong>
                      </div>
                    </div>
                  </div>
                  `)}
                </div>
                `, (0, fast_element_1.html) `
                <div class="text-center text-muted">
                  <div class="mb-3">
                    <i class="simple-icon-people" style="font-size: 2rem;"></i>
                  </div>
                  <div>${'knowledge.preview.no_avatars_using'.t()}</div>
                </div>
                `)}
                `)}
              </div>
            </div>
          </div>

          
          <div class="col-lg-6 mb-3">
            <div class="card shadow-sm h-100">
              <div class="card-body">
                <h5 class="card-title text-secondary mb-3">
                  <i class="simple-icon-graduation mr-2"></i>
                  ${'knowledge.preview.section.used_by_professions'.t()}
                </h5>
                ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                <div class="text-center">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">${'common.loading'.t()}</span>
                  </div>
                </div>
                `, (0, fast_element_1.html) `
                ${(0, fast_element_1.when)(x => x.usage.professions.length > 0, (0, fast_element_1.html) `
                <div class="list-group list-group-flush">
                  ${(0, fast_element_1.repeat)(x => x.usage.professions, (0, fast_element_1.html) `
                  <div class="list-group-item px-0">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 mr-3">
                        <i class="simple-icon-graduation text-primary"></i>
                      </div>
                      <div>
                        <strong>${x => x.name}</strong>
                      </div>
                    </div>
                  </div>
                  `)}
                </div>
                `, (0, fast_element_1.html) `
                <div class="text-center text-muted">
                  <div class="mb-3">
                    <i class="simple-icon-graduation" style="font-size: 2rem;"></i>
                  </div>
                  <div>${'knowledge.preview.no_professions_using'.t()}</div>
                </div>
                `)}
                `)}
              </div>
            </div>
          </div>
        </div>
        `)}

        ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">${'common.loading'.t()}</span>
          </div>
        </div>
        `)}

        ${(0, fast_element_1.when)(x => !x.loading && !x.knowledge, (0, fast_element_1.html) `
        <div class="alert alert-warning" role="alert">
          <i class="simple-icon-exclamation mr-2"></i>
          ${'knowledge.preview.not_found'.t()}
        </div>
        `)}
      </div>
    </div>
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.knowledge-preview-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
.knowledge-preview-page .icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.knowledge-preview-page .icon-circle i {
  font-size: 1.2rem;
}
.knowledge-preview-page .content-display {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 1rem;
  background-color: #f8f9fa;
}
.knowledge-preview-page .content-display pre {
  margin: 0;
  font-family: inherit;
  font-size: 0.9rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.knowledge-preview-page .list-group-item {
  border-left: none;
  border-right: none;
}
.knowledge-preview-page .list-group-item:first-child {
  border-top: none;
}
.knowledge-preview-page .list-group-item:last-child {
  border-bottom: none;
}
.knowledge-preview-page .list-group-item.list-group-item-action:hover {
  background-color: #f8f9fa;
}
.knowledge-preview-page .cursor-pointer {
  cursor: pointer;
}
.knowledge-preview-page .card {
  transition: box-shadow 0.15s ease-in-out;
}
.knowledge-preview-page .card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.knowledge-preview-page .text-wrap {
  word-wrap: break-word;
  word-break: break-word;
}`;
const shadowOptions = { "mode": "open" };
let KnowledgePreview = class KnowledgePreview extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.compact = false;
        this.loading = false;
        this.knowledgeId = null;
        this.knowledge = null;
        this.usage = { avatars: [], professions: [] };
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    get contentTypeLabel() {
        var _a;
        if (!((_a = this.knowledge) === null || _a === void 0 ? void 0 : _a.contentType))
            return 'knowledge.preview.content_type.text'.t();
        return `knowledge.preview.content_type.${this.knowledge.contentType}`.t();
    }
    get ragStatusLabel() {
        var _a;
        if (!((_a = this.knowledge) === null || _a === void 0 ? void 0 : _a.ragStatus))
            return 'knowledge.preview.rag_status.not_indexed'.t();
        return `knowledge.preview.rag_status.${this.knowledge.ragStatus}`.t();
    }
    get ragStatusIcon() {
        var _a;
        switch ((_a = this.knowledge) === null || _a === void 0 ? void 0 : _a.ragStatus) {
            case backendImport_1.KnowledgeRAGStatus.COMPLETED:
                return 'simple-icon-check';
            case backendImport_1.KnowledgeRAGStatus.PROCESSING:
                return 'simple-icon-refresh';
            case backendImport_1.KnowledgeRAGStatus.PENDING:
                return 'simple-icon-clock';
            case backendImport_1.KnowledgeRAGStatus.FAILED:
                return 'simple-icon-exclamation';
            default:
                return 'simple-icon-question';
        }
    }
    get ragStatusClass() {
        var _a;
        switch ((_a = this.knowledge) === null || _a === void 0 ? void 0 : _a.ragStatus) {
            case backendImport_1.KnowledgeRAGStatus.COMPLETED:
                return 'text-success';
            case backendImport_1.KnowledgeRAGStatus.PROCESSING:
                return 'text-info';
            case backendImport_1.KnowledgeRAGStatus.PENDING:
                return 'text-warning';
            case backendImport_1.KnowledgeRAGStatus.FAILED:
                return 'text-danger';
            default:
                return 'text-muted';
        }
    }
    async connectedCallback() {
        var _a;
        super.connectedCallback();
        if (!this.knowledgeId && ((_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.id)) {
            this.knowledgeId = this.routeParams.id;
        }
        if (this.knowledgeId) {
            await this.loadKnowledge();
        }
        console.log('compact:', this.compact);
    }
    async loadKnowledge() {
        var _a;
        if (!this.knowledgeId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('knowledge.get', {
                routeParams: { id: this.knowledgeId }
            });
            const knowledgeData = response.data;
            if (knowledgeData) {
                this.knowledge = knowledgeData;
                // Extract usage information from the loaded knowledge relationships
                this.usage = {
                    avatars: (knowledgeData.avatarKnowledge || []).map(ak => ({
                        id: String(ak.avatar.id),
                        name: ak.avatar.name
                    })),
                    professions: (knowledgeData.professionKnowledge || []).map(pk => ({
                        id: String(pk.profession.id),
                        name: pk.profession.name
                    }))
                };
            }
        }
        catch (e) {
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('knowledge.preview.error.load_failed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    getTagsDisplay() {
        var _a;
        if (!((_a = this.knowledge) === null || _a === void 0 ? void 0 : _a.tags) || this.knowledge.tags.length === 0) {
            return 'knowledge.preview.no_tags'.t();
        }
        return this.knowledge.tags.join(', ');
    }
    getFileDisplayName() {
        var _a;
        if (!((_a = this.knowledge) === null || _a === void 0 ? void 0 : _a.file))
            return '';
        return this.knowledge.file.originalName || this.knowledge.file.filename || '';
    }
    getFileSize() {
        var _a, _b;
        if (!((_b = (_a = this.knowledge) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.size))
            return '';
        const bytes = this.knowledge.file.size;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        if (bytes === 0)
            return '0 Bytes';
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    }
    back() {
        component_1.SiteMenu.goto.bind(this)('/ai/knowledge/list');
    }
    edit() {
        if (this.knowledgeId) {
            component_1.SiteMenu.goto.bind(this)(`/ai/knowledge/edit/${this.knowledgeId}`);
        }
    }
    nl2br(text) {
        if (!text)
            return '';
        return text.replace(/\n/g, '<br/>');
    }
};
exports.KnowledgePreview = KnowledgePreview;
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], KnowledgePreview.prototype, "compact", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgePreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], KnowledgePreview.prototype, "knowledgeId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IKnowledge !== "undefined" && backendImport_1.IKnowledge) === "function" ? _b : Object)
], KnowledgePreview.prototype, "knowledge", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], KnowledgePreview.prototype, "usage", void 0);
exports.KnowledgePreview = KnowledgePreview = __decorate([
    (0, client_1.RWSView)('knowledge-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], KnowledgePreview);
KnowledgePreview.defineComponent();
